import React, { useState, useCallback, useEffect } from "react";
import AuthBlocker from "./AuthBlocker";
import { useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import axios from "axios";
import apiUrls from "../config.js";
import { useAccessToken } from '../AccessTokenProvider';
import LoggerComponent from '../LoggerComponent.js';
import mensajesLog from "../mensajesLog.js";

import antena_am_csv from "../descargas/Formatos_Elementos_Servidor/AntenaAM/antena_am.csv";
import antena_am_json from "../descargas/Formatos_Elementos_Servidor/AntenaAM/antena_am.json";
import antena_am_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaAM/antena_am.xlsx";
import antena_am_xml from "../descargas/Formatos_Elementos_Servidor/AntenaAM/antena_am.xml";

import antena_fm_csv from "../descargas/Formatos_Elementos_Servidor/AntenaFM/antena_fm.csv";
import antena_fm_json from "../descargas/Formatos_Elementos_Servidor/AntenaFM/antena_fm.json";
import antena_fm_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaFM/antena_fm.xlsx";
import antena_fm_xml from "../descargas/Formatos_Elementos_Servidor/AntenaFM/antena_fm.xml";

import antena_gsm_csv from "../descargas/Formatos_Elementos_Servidor/AntenaGSM/antena_gsm.csv";
import antena_gsm_json from "../descargas/Formatos_Elementos_Servidor/AntenaGSM/antena_gsm.json";
import antena_gsm_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaGSM/antena_gsm.xlsx";
import antena_gsm_xml from "../descargas/Formatos_Elementos_Servidor/AntenaGSM/antena_gsm.xml";

import antena_lte_csv from "../descargas/Formatos_Elementos_Servidor/AntenaLTE/antena_lte.csv";
import antena_lte_json from "../descargas/Formatos_Elementos_Servidor/AntenaLTE/antena_lte.json";
import antena_lte_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaLTE/antena_lte.xlsx";
import antena_lte_xml from "../descargas/Formatos_Elementos_Servidor/AntenaLTE/antena_lte.xml";

import antena_microondas_csv from "../descargas/Formatos_Elementos_Servidor/AntenaMicroondas/antena_microondas.csv";
import antena_microondas_json from "../descargas/Formatos_Elementos_Servidor/AntenaMicroondas/antena_microondas.json";
import antena_microondas_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaMicroondas/antena_microondas.xlsx";
import antena_microondas_xml from "../descargas/Formatos_Elementos_Servidor/AntenaMicroondas/antena_microondas.xml";

import antena_tdt_csv from "../descargas/Formatos_Elementos_Servidor/AntenaTDT/antena_tdt.csv";
import antena_tdt_json from "../descargas/Formatos_Elementos_Servidor/AntenaTDT/antena_tdt.json";
import antena_tdt_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaTDT/antena_tdt.xlsx";
import antena_tdt_xml from "../descargas/Formatos_Elementos_Servidor/AntenaTDT/antena_tdt.xml";

import antena_wcdma_csv from "../descargas/Formatos_Elementos_Servidor/AntenaWCDMA/antena_wcdma.csv";
import antena_wcdma_json from "../descargas/Formatos_Elementos_Servidor/AntenaWCDMA/antena_wcdma.json";
import antena_wcdma_xlsx from "../descargas/Formatos_Elementos_Servidor/AntenaWCDMA/antena_wcdma.xlsx";
import antena_wcdma_xml from "../descargas/Formatos_Elementos_Servidor/AntenaWCDMA/antena_wcdma.xml";


import cable_coaxial_kml from "../descargas/Formatos_Elementos_Servidor/Cablecoaxial/cable_coaxial.kml";
import cable_coaxial_kmz from "../descargas/Formatos_Elementos_Servidor/Cablecoaxial/cable_coaxial.kmz";


import cable_fibra_acceso_kml from "../descargas/Formatos_Elementos_Servidor/CabledeFibraopticadelareddeacceso/cable_fibra_acceso.kml";
import cable_fibra_acceso_kmz from "../descargas/Formatos_Elementos_Servidor/CabledeFibraopticadelareddeacceso/cable_fibra_acceso.kmz";


import cable_fibra_transporte_kml from "../descargas/Formatos_Elementos_Servidor/CabledeFibraopticadelareddetransporte/cable_fibra_transporte.kml";
import cable_fibra_transporte_kmz from "../descargas/Formatos_Elementos_Servidor/CabledeFibraopticadelareddetransporte/cable_fibra_transporte.kmz";

import central_csv from "../descargas/Formatos_Elementos_Servidor/Central/central.csv";
import central_json from "../descargas/Formatos_Elementos_Servidor/Central/central.json";
import central_xlsx from "../descargas/Formatos_Elementos_Servidor/Central/central.xlsx";
import central_xml from "../descargas/Formatos_Elementos_Servidor/Central/central.xml";

import cmts_csv from "../descargas/Formatos_Elementos_Servidor/CMTS/cmts.csv";
import cmts_json from "../descargas/Formatos_Elementos_Servidor/CMTS/cmts.json";
import cmts_xlsx from "../descargas/Formatos_Elementos_Servidor/CMTS/cmts.xlsx";
import cmts_xml from "../descargas/Formatos_Elementos_Servidor/CMTS/cmts.xml";


import derecho_via_kml from "../descargas/Formatos_Elementos_Servidor/Derechosdevia/derecho_via.kml";
import derecho_via_kmz from "../descargas/Formatos_Elementos_Servidor/Derechosdevia/derecho_via.kmz";

import dslam_csv from "../descargas/Formatos_Elementos_Servidor/DSLAM/dslam.csv";
import dslam_json from "../descargas/Formatos_Elementos_Servidor/DSLAM/dslam.json";
import dslam_xlsx from "../descargas/Formatos_Elementos_Servidor/DSLAM/dslam.xlsx";
import dslam_xml from "../descargas/Formatos_Elementos_Servidor/DSLAM/dslam.xml";


import ducto_kml from "../descargas/Formatos_Elementos_Servidor/Ductos/ducto.kml";
import ducto_kmz from "../descargas/Formatos_Elementos_Servidor/Ductos/ducto.kmz";

import enlace_microondas_kml from "../descargas/Formatos_Elementos_Servidor/EnlaceMicroondasoVHF/enlace_microondas.kml";
import enlace_microondas_kmz from "../descargas/Formatos_Elementos_Servidor/EnlaceMicroondasoVHF/enlace_microondas.kmz";

import enodeb_csv from "../descargas/Formatos_Elementos_Servidor/eNodeB/enodeb.csv";
import enodeb_json from "../descargas/Formatos_Elementos_Servidor/eNodeB/enodeb.json";
import enodeb_xlsx from "../descargas/Formatos_Elementos_Servidor/eNodeB/enodeb.xlsx";
import enodeb_xml from "../descargas/Formatos_Elementos_Servidor/eNodeB/enodeb.xml";

import mgw_csv from "../descargas/Formatos_Elementos_Servidor/MGW/mgw.csv";
import mgw_json from "../descargas/Formatos_Elementos_Servidor/MGW/mgw.json";
import mgw_xlsx from "../descargas/Formatos_Elementos_Servidor/MGW/mgw.xlsx";
import mgw_xml from "../descargas/Formatos_Elementos_Servidor/MGW/mgw.xml";

import nodob_csv from "../descargas/Formatos_Elementos_Servidor/NodoB/nodob.csv";
import nodob_json from "../descargas/Formatos_Elementos_Servidor/NodoB/nodob.json";
import nodob_xlsx from "../descargas/Formatos_Elementos_Servidor/NodoB/nodob.xlsx";
import nodob_xml from "../descargas/Formatos_Elementos_Servidor/NodoB/nodob.xml";

import olt_csv from "../descargas/Formatos_Elementos_Servidor/OLT/olt.csv";
import olt_json from "../descargas/Formatos_Elementos_Servidor/OLT/olt.json";
import olt_xlsx from "../descargas/Formatos_Elementos_Servidor/OLT/olt.xlsx";
import olt_xml from "../descargas/Formatos_Elementos_Servidor/OLT/olt.xml";

import poste_csv from "../descargas/Formatos_Elementos_Servidor/Postes/poste.csv";
import poste_json from "../descargas/Formatos_Elementos_Servidor/Postes/poste.json";
import poste_xlsx from "../descargas/Formatos_Elementos_Servidor/Postes/poste.xlsx";
import poste_xml from "../descargas/Formatos_Elementos_Servidor/Postes/poste.xml";

import pozo_csv from "../descargas/Formatos_Elementos_Servidor/Pozos/pozo.csv";
import pozo_json from "../descargas/Formatos_Elementos_Servidor/Pozos/pozo.json";
import pozo_xlsx from "../descargas/Formatos_Elementos_Servidor/Pozos/pozo.xlsx";
import pozo_xml from "../descargas/Formatos_Elementos_Servidor/Pozos/pozo.xml";

import punto_interconexion_csv from "../descargas/Formatos_Elementos_Servidor/PuntosdeInterconexion/punto_interconexion.csv";
import punto_interconexion_json from "../descargas/Formatos_Elementos_Servidor/PuntosdeInterconexion/punto_interconexion.json";
import punto_interconexion_xlsx from "../descargas/Formatos_Elementos_Servidor/PuntosdeInterconexion/punto_interconexion.xlsx";
import punto_interconexion_xml from "../descargas/Formatos_Elementos_Servidor/PuntosdeInterconexion/punto_interconexion.xml";

import repetidor_csv from "../descargas/Formatos_Elementos_Servidor/Repetidor/repetidor.csv";
import repetidor_json from "../descargas/Formatos_Elementos_Servidor/Repetidor/repetidor.json";
import repetidor_xlsx from "../descargas/Formatos_Elementos_Servidor/Repetidor/repetidor.xlsx";
import repetidor_xml from "../descargas/Formatos_Elementos_Servidor/Repetidor/repetidor.xml";

import sala_transmision_csv from "../descargas/Formatos_Elementos_Servidor/SaladeTransmision/sala_transmision.csv";
import sala_transmision_json from "../descargas/Formatos_Elementos_Servidor/SaladeTransmision/sala_transmision.json";
import sala_transmision_xlsx from "../descargas/Formatos_Elementos_Servidor/SaladeTransmision/sala_transmision.xlsx";
import sala_transmision_xml from "../descargas/Formatos_Elementos_Servidor/SaladeTransmision/sala_transmision.xml";


import sector_gsm_kml from "../descargas/Formatos_Elementos_Servidor/SectorGSM/sector_gsm.kml";
import sector_gsm_kmz from "../descargas/Formatos_Elementos_Servidor/SectorGSM/sector_gsm.kmz";


import sector_lte_kml from "../descargas/Formatos_Elementos_Servidor/SectorLTE/sector_lte.kml";
import sector_lte_kmz from "../descargas/Formatos_Elementos_Servidor/SectorLTE/sector_lte.kmz";


import sector_wcdma_kml from "../descargas/Formatos_Elementos_Servidor/SectorWCDMA/sector_wcdma.kml";
import sector_wcdma_kmz from "../descargas/Formatos_Elementos_Servidor/SectorWCDMA/sector_wcdma.kmz";

import sitio_transmision_csv from "../descargas/Formatos_Elementos_Servidor/SitiodeTransmision/sitio_transmision.csv";
import sitio_transmision_json from "../descargas/Formatos_Elementos_Servidor/SitiodeTransmision/sitio_transmision.json";
import sitio_transmision_xlsx from "../descargas/Formatos_Elementos_Servidor/SitiodeTransmision/sitio_transmision.xlsx";
import sitio_transmision_xml from "../descargas/Formatos_Elementos_Servidor/SitiodeTransmision/sitio_transmision.xml";

import sitio_privado_csv from "../descargas/Formatos_Elementos_Servidor/Sitiosprivados/sitio_privado.csv";
import sitio_privado_json from "../descargas/Formatos_Elementos_Servidor/Sitiosprivados/sitio_privado.json";
import sitio_privado_xlsx from "../descargas/Formatos_Elementos_Servidor/Sitiosprivados/sitio_privado.xlsx";
import sitio_privado_xml from "../descargas/Formatos_Elementos_Servidor/Sitiosprivados/sitio_privado.xml";

import sitio_publico_csv from "../descargas/Formatos_Elementos_Servidor/Sitiospublicos/sitio_publico.csv";
import sitio_publico_json from "../descargas/Formatos_Elementos_Servidor/Sitiospublicos/sitio_publico.json";
import sitio_publico_xlsx from "../descargas/Formatos_Elementos_Servidor/Sitiospublicos/sitio_publico.xlsx";
import sitio_publico_xml from "../descargas/Formatos_Elementos_Servidor/Sitiospublicos/sitio_publico.xml";

import switch_atm_csv from "../descargas/Formatos_Elementos_Servidor/SwitchATM/switch_atm.csv";
import switch_atm_json from "../descargas/Formatos_Elementos_Servidor/SwitchATM/switch_atm.json";
import switch_atm_xlsx from "../descargas/Formatos_Elementos_Servidor/SwitchATM/switch_atm.xlsx";
import switch_atm_xml from "../descargas/Formatos_Elementos_Servidor/SwitchATM/switch_atm.xml";

import switch_otn_csv from "../descargas/Formatos_Elementos_Servidor/SwitchOTN/switch_otn.csv";
import switch_otn_json from "../descargas/Formatos_Elementos_Servidor/SwitchOTN/switch_otn.json";
import switch_otn_xlsx from "../descargas/Formatos_Elementos_Servidor/SwitchOTN/switch_otn.xlsx";
import switch_otn_xml from "../descargas/Formatos_Elementos_Servidor/SwitchOTN/switch_otn.xml";

import torre_csv from "../descargas/Formatos_Elementos_Servidor/Torres/torre.csv";
import torre_json from "../descargas/Formatos_Elementos_Servidor/Torres/torre.json";
import torre_xlsx from "../descargas/Formatos_Elementos_Servidor/Torres/torre.xlsx";
import torre_xml from "../descargas/Formatos_Elementos_Servidor/Torres/torre.xml";

import transmisor_csv from "../descargas/Formatos_Elementos_Servidor/Transmisor/transmisor.csv";
import transmisor_json from "../descargas/Formatos_Elementos_Servidor/Transmisor/transmisor.json";
import transmisor_xlsx from "../descargas/Formatos_Elementos_Servidor/Transmisor/transmisor.xlsx";
import transmisor_xml from "../descargas/Formatos_Elementos_Servidor/Transmisor/transmisor.xml";


import troncal_cobre_kml from "../descargas/Formatos_Elementos_Servidor/TroncaldeCobre/troncal_cobre.kml";
import troncal_cobre_kmz from "../descargas/Formatos_Elementos_Servidor/TroncaldeCobre/troncal_cobre.kmz";

import obra_civil_area_kml from "../descargas/Formatos_Elementos_Servidor/ObraCivilArea/obra_civil_area.kml";
import obra_civil_area_kmz from "../descargas/Formatos_Elementos_Servidor/ObraCivilArea/obra_civil_area.kmz";

import obra_civil_lineal_kml from "../descargas/Formatos_Elementos_Servidor/ObraCivilLineal/obra_civil_lineal.kml";
import obra_civil_lineal_kmz from "../descargas/Formatos_Elementos_Servidor/ObraCivilLineal/obra_civil_lineal.kmz";

import obra_civil_puntual_csv from "../descargas/Formatos_Elementos_Servidor/ObraCivilPuntual/obra_civil_puntual.csv";
import obra_civil_puntual_json from "../descargas/Formatos_Elementos_Servidor/ObraCivilPuntual/obra_civil_puntual.json";
import obra_civil_puntual_xlsx from "../descargas/Formatos_Elementos_Servidor/ObraCivilPuntual/obra_civil_puntual.xlsx";
import obra_civil_puntual_xml from "../descargas/Formatos_Elementos_Servidor/ObraCivilPuntual/obra_civil_puntual.xml";

const ListaFormatos = ({ token }) => {
  const { accessToken } = useAccessToken();
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [msg, setmsg] = useState("");
  const location = useLocation();
  const [jwt,setjwt]=useState(null);
  const loggerInstance = LoggerComponent();
  if (accessToken) {    
    getToken(accessToken);
    }
 
  async function getToken(token) {
    const f = {
      jwt: token
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    await axios
      .post(apiUrls.desencriptar, f, config)
      .then(async (response) => {
        try {
          var decodedToken = jwtDecode(response.data.jwt, { complete: true });
          setjwt(response.data.jwt);
          const data = {
            level: 'info',
            mensaje: response.data.jwt,
            accion: mensajesLog.ConsultarPlantillasEntro
          };
          loggerInstance.sendDataToApi(data);
          const ahora = Date.now() / 1000;
          if (decodedToken.exp < ahora) {
            throw new Error("Token no valido");
          }
          setTokenIsValid(true);
        } catch (error) {
          console.log(error);
          setmsg("Usted no tiene acceso a este sistema");
          setTokenIsValid(false);
          const data = {
            level: 'info',
            mensaje: jwt,
            accion: mensajesLog.ErrorAccesoSNII
          };
          loggerInstance.sendDataToApi(data);
        }
      })
      .catch((error) => {
        console.log(error);
        setmsg("Usted no tiene acceso a este sistema");
        setTokenIsValid(false);
        const data = {
          level: 'info',
          mensaje: jwt,
          accion: mensajesLog.ErrorAccesoSNII
        };
        loggerInstance.sendDataToApi(data);
      });
  }

  const formatos = [
    {
      tipoArchivo: "Antena AM",
      nombreArchivo: "antena_am",
      JSON: antena_am_json,
      XLSX: antena_am_xlsx,
      CSV: antena_am_csv,
      KMZ: "",
      KML: "",
      XML: antena_am_xml
    },
    {
      tipoArchivo: "Antena FM ",
      nombreArchivo: "antena_fm",
      JSON: antena_fm_json,
      XLSX: antena_fm_xlsx,
      CSV: antena_fm_csv,
      KMZ: "",
      KML: "",
      XML: antena_fm_xml
    },
    {
      tipoArchivo: "Antena GSM",
      nombreArchivo: "antena_gsm",
      JSON: antena_gsm_json,
      XLSX: antena_gsm_xlsx,
      CSV: antena_gsm_csv,
      KMZ: "",
      KML: "",
      XML: antena_gsm_xml
    },
    {
      tipoArchivo: "Antena LTE",
      nombreArchivo: "antena_lte",
      JSON: antena_lte_json,
      XLSX: antena_lte_xlsx,
      CSV: antena_lte_csv,
      KMZ: "",
      KML: "",
      XML: antena_lte_xml
    },
    {
      tipoArchivo: "Antena Microondas",
      nombreArchivo: "antena_microondas",
      JSON: antena_microondas_json,
      XLSX: antena_microondas_xlsx,
      CSV: antena_microondas_csv,
      KMZ: "",
      KML: "",
      XML: antena_microondas_xml
    },
    {
      tipoArchivo: "Antena TDT",
      nombreArchivo: "antena_tdt",
      JSON: antena_tdt_json,
      XLSX: antena_tdt_xlsx,
      CSV: antena_tdt_csv,
      KMZ: "",
      KML: "",
      XML: antena_tdt_xml
    },
    {
      tipoArchivo: "Antena WCDMA",
      nombreArchivo: "antena_wcdma",
      JSON: antena_wcdma_json,
      XLSX: antena_wcdma_xlsx,
      CSV: antena_wcdma_csv,
      KMZ: "",
      KML: "",
      XML: antena_wcdma_xml
    },
    {
      tipoArchivo: "Central ",
      nombreArchivo: "central",
      JSON: central_json,
      XLSX: central_xlsx,
      CSV: central_csv,
      KMZ: "",
      KML: "",
      XML: central_xml
    },
    {
      tipoArchivo: "CMTS ",
      nombreArchivo: "cmts",
      JSON: cmts_json,
      XLSX: cmts_xlsx,
      CSV: cmts_csv,
      KMZ: "",
      KML: "",
      XML: cmts_xml
    },
    {
      tipoArchivo: "DSLAM",
      nombreArchivo: "dslam",
      JSON: dslam_json,
      XLSX: dslam_xlsx,
      CSV: dslam_csv,
      KMZ: "",
      KML: "",
      XML: dslam_xml
    },
    {
      tipoArchivo: "eNodeB",
      nombreArchivo: "enodeb",
      JSON: enodeb_json,
      XLSX: enodeb_xlsx,
      CSV: enodeb_csv,
      KMZ: "",
      KML: "",
      XML: enodeb_xml
    },
    {
      tipoArchivo: "MGW ",
      nombreArchivo: "mgw",
      JSON: mgw_json,
      XLSX: mgw_xlsx,
      CSV: mgw_csv,
      KMZ: "",
      KML: "",
      XML: mgw_xml
    },
    {
      tipoArchivo: "Nodo B",
      nombreArchivo: "nodob",
      JSON: nodob_json,
      XLSX: nodob_xlsx,
      CSV: nodob_csv,
      KMZ: "",
      KML: "",
      XML: nodob_xml
    },
    {
      tipoArchivo: "OLT ",
      nombreArchivo: "olt",
      JSON: olt_json,
      XLSX: olt_xlsx,
      CSV: olt_csv,
      KMZ: "",
      KML: "",
      XML: olt_xml
    },
    {
      tipoArchivo: "Puntos de Interconexión",
      nombreArchivo: "punto_interconexion",
      JSON: punto_interconexion_json,
      XLSX: punto_interconexion_xlsx,
      CSV: punto_interconexion_csv,
      KMZ: "",
      KML: "",
      XML: punto_interconexion_xml
    },
    {
      tipoArchivo: "Repetidor  ",
      nombreArchivo: "repetidor",
      JSON: repetidor_json,
      XLSX: repetidor_xlsx,
      CSV: repetidor_csv,
      KMZ: "",
      KML: "",
      XML: repetidor_xml
    },
    {
      tipoArchivo: "Sector GSM",
      nombreArchivo: "sector_gsm",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: sector_gsm_kmz,
      KML: sector_gsm_kml,
      XML: ""
    },
    {
      tipoArchivo: "Sector LTE",
      nombreArchivo: "sector_lte",
      JSON:"",
      XLSX: "",
      CSV: "",
      KMZ: sector_lte_kmz,
      KML: sector_lte_kml,
      XML: ""
    },
    {
      tipoArchivo: "Sector WCDMA",
      nombreArchivo: "sector_wcdma",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: sector_wcdma_kmz,
      KML: sector_wcdma_kml,
      XML: ""
    },
    {
      tipoArchivo: "Switch ATM ",
      nombreArchivo: "switch_atm",
      JSON: switch_atm_json,
      XLSX: switch_atm_xlsx,
      CSV: switch_atm_csv,
      KMZ: "",
      KML: "",
      XML: switch_atm_xml
    },
    {
      tipoArchivo: "Switch OTN ",
      nombreArchivo: "switch_otn",
      JSON: switch_otn_json,
      XLSX: switch_otn_xlsx,
      CSV: switch_otn_csv,
      KMZ: "",
      KML: "",
      XML: switch_otn_xml
    },
    {
      tipoArchivo: "Transmisor ",
      nombreArchivo: "transmisor",
      JSON: transmisor_json,
      XLSX: transmisor_xlsx,
      CSV: transmisor_csv,
      KMZ: "",
      KML: "",
      XML: transmisor_xml
    },
    {
      tipoArchivo: "Sala de Transmisión",
      nombreArchivo: "sala_transmision",
      JSON: sala_transmision_json,
      XLSX: sala_transmision_xlsx,
      CSV: sala_transmision_csv,
      KMZ: "",
      KML: "",
      XML: sala_transmision_xml
    },
    {
      tipoArchivo: "Sitio de Transmisión",
      nombreArchivo: "sitio_transmision",
      JSON: sitio_transmision_json,
      XLSX: sitio_transmision_xlsx,
      CSV: sitio_transmision_csv,
      KMZ: "",
      KML: "",
      XML: sitio_transmision_xml
    },
    {
      tipoArchivo: "Torres ",
      nombreArchivo: "torre",
      JSON: torre_json,
      XLSX: torre_xlsx,
      CSV: torre_csv,
      KMZ: "",
      KML: "",
      XML: torre_xml
    },
    {
      tipoArchivo: "Ductos ",
      nombreArchivo: "ducto",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: ducto_kmz,
      KML: ducto_kml,
      XML: ""
    },
    {
      tipoArchivo: "Postes",
      nombreArchivo: "poste",
      JSON: poste_json,
      XLSX: poste_xlsx,
      CSV: poste_csv,
      KMZ: "",
      KML: "",
      XML: poste_xml
    },
    {
      tipoArchivo: "Pozos  ",
      nombreArchivo: "pozo",
      JSON: pozo_json,
      XLSX: pozo_xlsx,
      CSV: pozo_csv,
      KMZ: "",
      KML: "",
      XML: pozo_xml
    },
    {
      tipoArchivo: "Cable Coaxial ",
      nombreArchivo: "cable_coaxial",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: cable_coaxial_kmz,
      KML: cable_coaxial_kml,
      XML: ""
    },
    {
      tipoArchivo: "Enlace Microondas o VHF",
      nombreArchivo: "enlace_microondas",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: enlace_microondas_kmz,
      KML: enlace_microondas_kml,
      XML: ""
    },
    {
      tipoArchivo: "Cable de Fibra óptica de la red de acceso ",
      nombreArchivo: "cable_fibra_acceso",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: cable_fibra_acceso_kmz,
      KML: cable_fibra_acceso_kml,
      XML: ""
    },
    {
      tipoArchivo: "Cable de Fibra óptica de la red de transporte",
      nombreArchivo: "cable_fibra_transporte",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: cable_fibra_transporte_kmz,
      KML: cable_fibra_transporte_kml,
      XML: ""
    },
    {
      tipoArchivo: "Troncal de Cobre ",
      nombreArchivo: "troncal_cobre",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: troncal_cobre_kmz,
      KML: troncal_cobre_kml,
      XML: ""
    },
    {
      tipoArchivo: "Sitios públicos  ",
      nombreArchivo: "sitio_publico",
      JSON: sitio_publico_json,
      XLSX: sitio_publico_xlsx,
      CSV: sitio_publico_csv,
      KMZ: "",
      KML: "",
      XML: sitio_publico_xml
    },
    {
      tipoArchivo: "Sitios privados  ",
      nombreArchivo: "sitio_privado",
      JSON: sitio_privado_json,
      XLSX: sitio_privado_xlsx,
      CSV: sitio_privado_csv,
      KMZ: "",
      KML: "",
      XML: sitio_privado_xml
    },
    {
      tipoArchivo: "Derechos de vía ",
      nombreArchivo: "derecho_via",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: derecho_via_kmz,
      KML: derecho_via_kml,
      XML: ""
    },
    {
      tipoArchivo: "Obra Civil Área ",
      nombreArchivo: "obra_civil_area",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: obra_civil_area_kmz,
      KML: obra_civil_area_kml,
      XML: ""
    },
    {
      tipoArchivo: "Obra Civil Lineal ",
      nombreArchivo: "obra_civil_lineal",
      JSON: "",
      XLSX: "",
      CSV: "",
      KMZ: obra_civil_lineal_kmz,
      KML: obra_civil_lineal_kml,
      XML: ""
    },
    ,
    {
      tipoArchivo: "Obra Civil Puntual",
      nombreArchivo: "obra_civil_puntual",
      JSON: obra_civil_puntual_json,
      XLSX: obra_civil_puntual_xlsx,
      CSV: obra_civil_puntual_csv,
      KMZ: "",
      KML: "",
      XML: obra_civil_puntual_xml
    }
  ];

  const downloadXML = (archivo, nombre) => {
    fetch(archivo)
      .then((response) => response.text())
      .then((xmlContent) => {

        const xmlBlob = new Blob([xmlContent], { type: "application/xml" });
        const xmlURL = window.URL.createObjectURL(xmlBlob);
        const link = document.createElement("a");
        link.href = xmlURL;
        link.setAttribute("download", nombre); // Especifica el nombre de archivo aquí
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        const data = {
          level: 'info',
          mensaje: jwt,
          accion: mensajesLog.ConsultarPlantillasDescarga +": "+nombre
        };
        loggerInstance.sendDataToApi(data);
      })
      .catch((error) => console.error("Error al descargar XML:", error));
  };

  const downloadkmz = (archivo, nombre) => {
    fetch(archivo)
      .then((response) => response.blob())
      .then((blobContent) => {

        const blob = new Blob([blobContent], { type: "application/vnd.google-earth.kmz" });
        const blobURL = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobURL;
        link.setAttribute("download", nombre); // Especifica el nombre de archivo aquí
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        const data = {
          level: 'info',
          mensaje: jwt,
          accion: mensajesLog.ConsultarPlantillasDescarga + ": " + nombre
        };
        loggerInstance.sendDataToApi(data);
      })
      .catch((error) => console.error("Error al descargar KMZ:", error));
  };
  const downloadXLSX = (archivo, nombre) => {
    fetch(archivo)
      .then((response) => response.arrayBuffer())
      .then((xlsxContent) => {
        const xlsxBlob = new Blob([xlsxContent], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const xlsxURL = window.URL.createObjectURL(xlsxBlob);
        const link = document.createElement("a");
        link.href = xlsxURL;
        link.setAttribute("download", nombre); // Especifica el nombre de archivo aquí
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        document.body.removeChild(link);
        const data = {
          level: 'info',
          mensaje: jwt,
          accion: mensajesLog.ConsultarPlantillasDescarga +": "+nombre
        };
        loggerInstance.sendDataToApi(data);
      })
      .catch((error) => console.error("Error al descargar XLSX:", error));
  };

  function getTd(tipoArchivo, td) {
    return tipoArchivo !== "" ? td : "";
  }
  return (
    <>
      <AuthBlocker tokenIsValid={tokenIsValid} msg={msg} />
      <div className="container-fluid">
        <div id="contentroot">
      <div className="card shadow mt-3">
        <div className="card-header py-3 text-center ">
          <h3 className="m-0 fw-bold text-gray-500">
            {" "}
            Plantillas de Descarga Disponibles por Objeto de Entrega
          </h3>
          <br/>
          <h5 className="m-0 fw-bold text-gray-500">
            Seleccione el ícono de descarga disponible en cada formato por
            objeto
          </h5>
          <br/>
          <h5 className="text-danger">
            <strong>
             Nota Importante: Conservar el nombre de la plantilla sin cambios. Evitar
             renombramientos por sistema, incluidas secuencias numéricas. 
             El sistema rechazará la entrega de archivos cuyo nombre sea distinto al nombre definido por la plantilla base.
             Ejemplo:Nombre correcto: "antena_am.json" y Nombre incorrecto: "antena_am (1).json"
             
            </strong>
          </h5>
        </div>
        <div className="card-body">
          <div
            className="table-responsive table mt-2 table-wrapper"
            id="dataTable"
            role="grid"
            aria-describedby="dataTable_info"
          >
            <table className="table text-gray-500" id="dataTable">
              <thead>
                <tr>
                  <th>Nombre de objeto</th>
                  <th></th>
                  <th></th>
                  <th>JSON</th>
                  <th>XLSX</th>
                  <th>CSV</th>
                  <th>KMZ</th>
                  <th>KML</th>
                  <th>XML </th>
                </tr>
              </thead>
              <tbody>
                {formatos.map((x, index) => (
                  <tr key={index}>
                    <td>
                      <i
                        className="fas fa-file-alt"
                        width="50"
                        height="50"
                        style={{
                          fontSize: "15px",
                          color: "#237e8b",
                          borderWidth: "20px",
                          borderRadius: "46%",
                          transform: " rotate(-15deg)",
                          boxShadow: "0px 0px 6px 1px"
                        }}
                      ></i>{" "}
                      &nbsp; {x.tipoArchivo}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {getTd(
                        x.JSON,
                        <a
                          href={URL.createObjectURL(
                            new Blob([JSON.stringify(x.JSON)], {
                              type: "application/json"
                            })
                          )}
                          download={x.nombreArchivo + ".json"}
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                    <td>
                      {getTd(
                        x.XLSX,
                        <a
                          href="#"
                          onClick={() =>
                            downloadXLSX(x.XLSX, x.nombreArchivo + ".xlsx")
                          }
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                    <td>
                      {getTd(
                        x.CSV,
                        <a
                          href="#"
                          onClick={() =>
                            downloadXML(x.CSV, x.nombreArchivo + ".csv")
                          }
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                    <td>
                      {getTd(
                        x.KMZ,
                        <a
                          href="#"
                          onClick={() =>
                            downloadkmz(x.KMZ, x.nombreArchivo + ".kmz")
                          }
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                    <td>
                      {getTd(
                        x.KML,
                        <a
                          href="#"
                          onClick={() =>
                            downloadXML(x.KML, x.nombreArchivo + ".kml")
                          }
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                    <td>
                      {getTd(
                        x.XML,
                        <a
                          href="#"
                          onClick={() =>
                            downloadXML(x.XML, x.nombreArchivo + ".xml")
                          }
                          data-bss-hover-animate="pulse"
                        >
                          <span
                            className="badge text-center border rounded shadow-lg  bg-secondary bg-gradient"
                            data-bs-toggle="tooltip"
                            data-bss-tooltip=""
                            title="Descarga"
                          >
                            {" "}
                            <i className="fas fa-cloud-download-alt"></i>
                            <br />
                          </span>
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
         <footer className="bg-white sticky-footer">
        <div className="container my-auto">
          <div className="text-center my-auto copyright">
            <span>Copyright © -is-2023</span>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
};
export default ListaFormatos;
